export default __webpack_public_path__ + "static/media/play_button.276eda3b.svg";